import { apiClient } from './client';
import { Company, PaginatedResponse, CompaniesListParams } from '../types';

export async function getCompanies(params: CompaniesListParams = {}): Promise<PaginatedResponse<Company>> {
  const { data } = await apiClient.get<PaginatedResponse<Company>>('/companies', { params });
  return data;
}

export async function getCompany(id: string): Promise<{ data: Company }> {
  const { data } = await apiClient.get<{ data: Company }>(`/companies/${id}`);
  return data;
}

export async function createCompany(payload: Partial<Company>): Promise<{ data: Company }> {
  const { data } = await apiClient.post<{ data: Company }>('/companies', payload);
  return data;
}

export async function updateCompany(id: string, payload: Partial<Company>): Promise<{ data: Company }> {
  const { data } = await apiClient.put<{ data: Company }>(`/companies/${id}`, payload);
  return data;
}

export async function deleteCompany(id: string): Promise<void> {
  await apiClient.delete(`/companies/${id}`);
}
